import React, { useRef } from 'react';
import { translate } from '../Services/translation'
import BuyButton from '../Containers/BuyButton.container';

const ProductCardSmall = ({ product, theme }) => {
    const buyButtonRef = useRef(null)
    const cardBaseClass = `product-card-small`
    const cardThemeClass = theme != "" ? `${cardBaseClass}--${theme}` : ''
    const isInStock = product.showBuyButton && product.isStockBalanceAboveLimit

    return (
        <div className={`${cardBaseClass} ${cardThemeClass}`}>
            <a href={product.linkUrl} itemProp="url" className={`${cardBaseClass}__link`}>
                <figure className={`${cardBaseClass}__figure`}>
                    <img className={`${cardBaseClass}__image`} itemProp="image" src={product.imageSrc} />
                </figure>
                <article className={`${cardBaseClass}__content`}>
                    <div className={`${cardBaseClass}__header`}>
                        <h3 itemProp="name" className={`${cardBaseClass}__title`}>{product.title}</h3>
                    </div>
                </article>
            </a>
            <div className={`${cardBaseClass}__footer`}>
                <div className={`${cardBaseClass}__price-wrapper`}>
                    {
                        product.campaignPrice ? (
                            <div className={`${cardBaseClass}-price ${cardBaseClass}-price--campaign`}>
                                <div className={`${cardBaseClass}-price--campaign__recommended`}>{product.recommendedPrice}</div>
                                <div className={`${cardBaseClass}-price--campaign__campaign`}>{product.campaignPrice}</div>
                            </div>
                        ) : (
                            <div className={`${cardBaseClass}-price`}>
                                <div className={`${cardBaseClass}-price__recommended`}>{product.recommendedPrice}</div>
                            </div>
                        )
                    }
                </div>
                <div className={`${cardBaseClass}__button-wrapper`} ref={buyButtonRef}>
                    {
                        <BuyButton {...{ 
                            isShowMore: !isInStock,
                            label: isInStock ? translate('product.buy.small') : translate('product.readMore'),
                            articleNumber: product.addToCartArticleNumber,
                            cssClass: `button button--buy button--buy-small`,
                            href: product.linkUrl 
                        }} />
                    }
                </div>
            </div>
        </div>
    )
}

export default ProductCardSmall;
